import { Resource } from "./Resource";
import { ResourceIdentifier } from "./ResourceIdentifier";
import { Log, LogGroup } from ".././MyHelpers";
import { ImageResource } from "./ImageResource";
import { JSONResource } from "./JSONResource";
import  { PixiSprite} from "../slot/Sprite/PixiSprite"
export class PixiSpriteResource extends Resource
{
	get Name(): string {
		return this.name;
	}
	get Type(): string {
		return "pixi";
	}

	get LogName(): string {
		return "PixiSpriteResource-" + this.name;
	}
	
	protected resid: ResourceIdentifier = null;
	protected logGroup: LogGroup = null;

	public imageResource: ImageResource = null;
	protected imageLoaded: boolean = false;

	public jsonResource: JSONResource = null;
	protected jsonLoaded: boolean = false;

	protected anyLoadError: boolean = false;


	//protected additionalProperties: SpriteAdditionalProperties = null;
	protected decodeOnLoad: boolean = false;

	// always make a copy of sprite, not to interfere with playing
	// note - copy creates shallow copy, only the sprite state, but the image data is shared
	protected _sprite: PixiSprite = null;
	public get sprite(): PixiSprite
	{
		return this._sprite.Copy() as PixiSprite;
	}

	protected decodeStartTime: number = 0;

	protected static readonly ImageExtension = ".png";
	protected static readonly JsonExtension = ".json";

	public constructor(path: string, resid: ResourceIdentifier, required: boolean = true, logGroup: LogGroup = null, decodeOnLoad: boolean = false)
	{
		super(path, resid.ID(), required);

		this.resid = resid;
		this.logGroup = logGroup;

		this.imageResource = new ImageResource(path + PixiSpriteResource.ImageExtension, this.resid.Add("img").ID(), required);
		this.jsonResource  = new JSONResource(path + PixiSpriteResource.JsonExtension, this.resid.Add("json").ID(), required);

		this.decodeOnLoad = decodeOnLoad;

		this.imageResource.AddOnLoadedCallback(() => {
			this.imageLoaded = true;
			if (this.jsonLoaded) this.Decode();
		});

		this.jsonResource.AddOnLoadedCallback(() => {
			this.jsonLoaded = true;
			if (this.imageLoaded) this.Decode();
		});

		this.imageResource.AddOnLoadErrorCallback(() => {
			if (!this.anyLoadError)
			{
				this.anyLoadError = true;
				this.LoadError()
			}
		});

		this.jsonResource.AddOnLoadErrorCallback(() => {
			if (!this.anyLoadError)
			{
				this.anyLoadError = true;
				this.LoadError()
			}
		});
	}

	protected Decode(): void
	{
		try
		{
			this._sprite = new PixiSprite(this.imageResource.img, this.jsonResource.json, this.path, this.resid, this.logGroup);
			//Sprite.Create(this.imageResource.img, this.jsonResource.json, this.resid, this.logGroup);

			if (this.decodeOnLoad)
			{
				this._sprite.AddOnDecodedCallbackSingleShot(() => {
					this.Loaded();
				});

				this._sprite.Decode();
			}
			else
			{
				this.Loaded();
			}
		}
		catch (ex)
		{
			Log.Error(this.LogName, `Error decoding sprite: ${JSON.stringify(ex)}`);
			this.LoadError();
		}
	}

	public Load(prevenCache: boolean = false): void {
		this.imageResource.Load(prevenCache);
		this.jsonResource.Load(prevenCache);
	}

	public override Reload(preventCache: boolean = false): void {
		this.anyLoadError = false;
		this.imageLoaded = false;
		this.jsonLoaded = false;


		this.Load(preventCache);
	}

	public override GetPaths(): string[]
	{
		return [
			this.path + PixiSpriteResource.ImageExtension,
			this.path + PixiSpriteResource.JsonExtension,
			...this.altPaths
		];
	}
}